import { AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { PrinterListTypes } from '../users/types'

export class PrintersService {
  static getPrintersList(): Promise<AxiosResponse<PrinterListTypes>> {
    return apiService.get<AxiosResponse<PrinterListTypes>>('/users/printers')
  }
}
